import LabelRentalType from '../../../../../pages/vip/features/label-rental-type/index';

export default LabelRentalType;
